import React from "react";

const SimplecastIcon = (props) => {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 86 84"
      style={{
        verticalAlign: "bottom",
      }}
      {...props}
    >
      <g fill="currentColor" fillRule="nonzero">
        <path d="M85.01 0v83.99H.736V0H85.01zm-5.618 5.6H6.353v72.79h73.04V5.6z" />
        <path d="M17.59 16.798V67.19h50.566zM64.182 52.432L32.401 20.758l3.972-3.96 31.783 31.674zM64.182 36.594l-15.89-15.837 3.972-3.96 15.892 15.838z" />
      </g>
    </svg>
  );
};

export default SimplecastIcon;
